<template>
  <teleport to="body">
    <div class="centro-detalle-backdrop">
      <div class="centro-detalle-card">
        <button type="button" class="centro-detalle-close" @click="$emit('cerrar')">✕</button>

        <header class="centro-detalle-header">
          <p class="centro-detalle-kicker">Centro de activación</p>
          <h2 class="centro-detalle-title">{{ centro?.nombre || 'Sin nombre' }}</h2>
          <p class="centro-detalle-subtitle">
            {{ centro?.retailer_nombre || 'Sin retailer' }} · {{ centro?.pais || 'Mexico' }}
          </p>

          <div class="centro-detalle-status-row">
            <span class="centro-detalle-status-chip" :class="centro?.activo == 1 ? 'is-active' : 'is-inactive'">
              {{ centro?.activo == 1 ? 'Activo' : 'Inactivo' }}
            </span>
          </div>
        </header>

        <div class="centro-detalle-body">
          <section class="centro-detalle-section">
            <p class="centro-detalle-section-title">Ficha comercial</p>
            <div class="centro-detalle-grid">
              <div class="centro-detalle-field">
                <span class="centro-detalle-label">País</span>
                <span class="centro-detalle-value">{{ centro?.pais || 'Mexico' }}</span>
              </div>
              <div class="centro-detalle-field">
                <span class="centro-detalle-label">Retailer</span>
                <span class="centro-detalle-value">{{ centro?.retailer_nombre || '—' }}</span>
              </div>
              <div class="centro-detalle-field">
                <span class="centro-detalle-label">Número de tienda</span>
                <span class="centro-detalle-value">{{ centro?.numero_tienda || '—' }}</span>
              </div>
              <div class="centro-detalle-field">
                <span class="centro-detalle-label">Display</span>
                <span class="centro-detalle-value">{{ centro?.display || '—' }}</span>
              </div>
            </div>
          </section>

          <section class="centro-detalle-section">
            <p class="centro-detalle-section-title">Ubicación</p>
            <div class="centro-detalle-grid">
              <div class="centro-detalle-field centro-detalle-field--full">
                <span class="centro-detalle-label">Dirección</span>
                <span class="centro-detalle-value">{{ centro?.direccion || '—' }}</span>
              </div>
              <div class="centro-detalle-field">
                <span class="centro-detalle-label">Ciudad</span>
                <span class="centro-detalle-value">{{ centro?.ciudad || '—' }}</span>
              </div>
              <div class="centro-detalle-field">
                <span class="centro-detalle-label">Estado</span>
                <span class="centro-detalle-value">{{ centro?.estado || '—' }}</span>
              </div>
            </div>
          </section>

          <section class="centro-detalle-section">
            <p class="centro-detalle-section-title">Contacto</p>
            <div class="centro-detalle-grid">
              <div class="centro-detalle-field">
                <span class="centro-detalle-label">Nombre de contacto</span>
                <span class="centro-detalle-value">{{ centro?.contacto_nombre || '—' }}</span>
              </div>
              <div class="centro-detalle-field">
                <span class="centro-detalle-label">Teléfono</span>
                <span class="centro-detalle-value">{{ centro?.contacto_telefono || '—' }}</span>
              </div>
              <div class="centro-detalle-field centro-detalle-field--full">
                <span class="centro-detalle-label">Correo</span>
                <span class="centro-detalle-value">{{ centro?.contacto_email || '—' }}</span>
              </div>
            </div>
          </section>

          <section class="centro-detalle-section centro-detalle-section--stacked">
            <div class="centro-detalle-field">
              <span class="centro-detalle-label">Horarios de entrega</span>
              <p class="centro-detalle-multiline">{{ normalizedHorarios || 'Sin horarios registrados.' }}</p>
            </div>
            <div class="centro-detalle-field">
              <span class="centro-detalle-label">Notas</span>
              <p class="centro-detalle-multiline">{{ normalizedNotas || 'Sin notas adicionales.' }}</p>
            </div>
          </section>
        </div>

        <footer class="centro-detalle-footer">
          <button type="button" class="centro-detalle-btn" @click="$emit('cerrar')">Cerrar</button>
        </footer>
      </div>
    </div>
  </teleport>
</template>

<script>
export default {
  name: 'DetalleCentroActivacion',
  props: {
    centro: {
      type: Object,
      required: true,
    },
  },
  emits: ['cerrar'],
  computed: {
    normalizedHorarios() {
      return this.normalizeMultiline(this.centro?.horarios_entrega);
    },
    normalizedNotas() {
      return this.normalizeMultiline(this.centro?.notas);
    },
  },
  methods: {
    normalizeMultiline(value) {
      if (!value || typeof value !== 'string') return '';
      let v = value.trim();
      if ((v.startsWith('"') && v.endsWith('"')) || (v.startsWith("'") && v.endsWith("'"))) {
        v = v.slice(1, -1);
      }
      return v.replace(/\\r\\n/g, '\n').replace(/\\n/g, '\n').replace(/\\r/g, '');
    },
  },
};
</script>

<style scoped>
.centro-detalle-backdrop {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background: radial-gradient(circle at 0 0, rgba(15, 23, 42, 0.7), rgba(15, 23, 42, 0.97));
  backdrop-filter: blur(18px);
}
.centro-detalle-card {
  position: relative;
  width: 100%;
  max-width: 760px;
  max-height: min(90vh, 680px);
  padding: 1.5rem 1.6rem 1.25rem;
  border-radius: 1.6rem;
  background: radial-gradient(circle at 0 0, rgba(148, 163, 184, 0.35), rgba(15, 23, 42, 0.98));
  border: 1px solid rgba(148, 163, 184, 0.7);
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.95), 0 0 0 1px rgba(15, 23, 42, 0.9);
  overflow-y: auto;
}
.centro-detalle-card::-webkit-scrollbar { width: 6px; }
.centro-detalle-card::-webkit-scrollbar-thumb { background: rgba(148, 163, 184, 0.7); border-radius: 999px; }
.centro-detalle-card::-webkit-scrollbar-track { background: transparent; }
.centro-detalle-close {
  position: absolute; top: 0.7rem; right: 0.75rem; width: 26px; height: 26px; border-radius: 999px; border: 1px solid rgba(148, 163, 184, 0.7); background: rgba(15, 23, 42, 0.95); color: #e5e7eb; cursor: pointer;
}
.centro-detalle-header { margin-bottom: 1rem; padding-right: 2rem; }
.centro-detalle-kicker { font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.18em; color: #9ca3af; margin-bottom: 0.25rem; }
.centro-detalle-title { font-size: 1.1rem; font-weight: 600; color: #e5e7eb; }
.centro-detalle-subtitle { margin-top: 0.25rem; font-size: 0.8rem; color: #94a3b8; }
.centro-detalle-status-row { margin-top: 0.5rem; }
.centro-detalle-status-chip { display: inline-flex; align-items: center; padding: 0.18rem 0.6rem; border-radius: 999px; font-size: 0.72rem; }
.centro-detalle-status-chip.is-active { background: rgba(34, 197, 94, 0.16); color: #bbf7d0; }
.centro-detalle-status-chip.is-inactive { background: rgba(148, 163, 184, 0.14); color: #cbd5e1; }
.centro-detalle-body { display: flex; flex-direction: column; gap: 0.9rem; }
.centro-detalle-section { padding: 0.85rem 0.9rem; border-radius: 1rem; background: rgba(15, 23, 42, 0.88); border: 1px solid rgba(148, 163, 184, 0.45); }
.centro-detalle-section--stacked { display: flex; flex-direction: column; gap: 0.75rem; }
.centro-detalle-section-title { font-size: 0.78rem; text-transform: uppercase; letter-spacing: 0.15em; color: #9ca3af; margin-bottom: 0.55rem; }
.centro-detalle-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 0.75rem 0.9rem; }
.centro-detalle-field { display: flex; flex-direction: column; gap: 0.18rem; }
.centro-detalle-field--full { grid-column: 1 / -1; }
.centro-detalle-label { font-size: 0.75rem; color: #94a3b8; text-transform: uppercase; letter-spacing: 0.08em; }
.centro-detalle-value { font-size: 0.84rem; color: #e5e7eb; word-break: break-word; }
.centro-detalle-multiline { margin: 0; font-size: 0.84rem; color: #e5e7eb; white-space: pre-line; line-height: 1.45; }
.centro-detalle-footer { margin-top: 1rem; display: flex; justify-content: flex-end; }
.centro-detalle-btn { border-radius: 999px; border: 1px solid rgba(148, 163, 184, 0.7); background: rgba(15, 23, 42, 0.94); color: #e5e7eb; padding: 0.45rem 1rem; cursor: pointer; }
@media (max-width: 768px) { .centro-detalle-grid { grid-template-columns: 1fr; } }
</style>
